import { collection, getDocs } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { db } from "../../../firebase";

export type StaffUser = {
  id: string;
  name?: string;
  email?: string;
  role?: "superadmin" | "admin" | "user" | string;
  approvalStatus?: "approved" | "pending";
};

const functions = getFunctions(undefined, "europe-west1");

function normaliseStaffUser(id: string, raw: Record<string, any>): StaffUser {
  return {
    id,
    name: typeof raw.name === "string" ? raw.name : "",
    email: typeof raw.email === "string" ? raw.email : "",
    role:
      raw.role === "superadmin" || raw.role === "admin" || raw.role === "user"
        ? raw.role
        : "user",
    approvalStatus: raw.approvalStatus === "pending" ? "pending" : "approved",
  };
}

export async function listStaffUsers() {
  const snap = await getDocs(collection(db, "users"));

  return snap.docs
    .map((userDoc) => normaliseStaffUser(userDoc.id, userDoc.data() as Record<string, any>))
    .sort((a, b) => {
      const roleRank = (role?: string) =>
        role === "superadmin" ? 0 : role === "admin" ? 1 : 2;
      const byRole = roleRank(a.role) - roleRank(b.role);
      if (byRole !== 0) return byRole;

      return String(a.name || a.email || a.id).localeCompare(
        String(b.name || b.email || b.id)
      );
    });
}

export async function setUserStaffRole(userId: string, role: "user" | "admin") {
  const callable = httpsCallable<
    { userId: string; role: "user" | "admin" },
    { ok: boolean }
  >(functions, "setUserStaffRole");

  try {
    return await callable({ userId, role });
  } catch (err: any) {
    throw new Error(err?.message || "Failed to update staff role.");
  }
}
